// extracted by mini-css-extract-plugin
export default {"wrapper":"wA-z","viewport":"xA-z","container":"yA-z","slide":"zA-z"};